const Substrates = () => import('./_views/substrates');

export default [
  {
    path: '/additional/substrates',
    name: 'substrates',
    component: Substrates,
    meta: {
      title: 'Substrates',
      group: 'additional',
      navigation: {
        position: 5,
        name: 'Substrates',
        specialQueries: ['suffix'],
        to: {
          name: 'substrates',
          query: {
            suffix: '',
            pageNum: '1',
          },
        },
      },
    },
  },
];
